import { Button, Box, Typography, Grid } from "@mui/material";
import FocusAreas from "../FocusAreas";
import pic1 from '../../images/D3.png';
import pic2 from '../../images/D4.png';

export default function ResearchSection() {
  return (
    <>
    <Box sx={{width: '100%' , background: '#fff'}}>
    <Box sx={{ width: "97%", mx: "auto", px: 2, py: { xs: 6, md: 8 } , background: '#fff', height: '100%'}}>
      <Grid container spacing={4} alignItems="center">
        <Grid item xs={12} md={6}>
          <Box>
            <Box
              component="span"
              sx={{
                backgroundColor: "#6B46C1",
                color: "white",
                px: 2,
                py: 0.5,
                borderRadius: 1,
                display: "inline-block",
              }}
            >
              Research
            </Box>
            <Typography
              variant="h3"
              sx={{
                color: "#1E1B4B",
                fontWeight: "bold",
                mt: 2,
                lineHeight: 1.2,
              }}
            >
              Markoknow Research & Development (R&D)
            </Typography>
            <Typography variant="body1" sx={{ color: "gray", maxWidth: "500px", mt: 2 }}>
              Enhancing the Innovation through major efforts in Technology, Data, Robotics and AI/ML
            </Typography>
            <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2, mt: 3 }}>
              <Button
                sx={{
                  backgroundColor: "#1E1B4B",
                  color: "white",
                  px: 4,
                  ":hover": { backgroundColor: "#2D2A6B" },
                }}
              >
                Partner Us
              </Button>
              <Button
                variant="outlined"
                sx={{
                  borderColor: "#1E1B4B",
                  color: "#1E1B4B",
                  px: 4,
                  ":hover": { backgroundColor: "#1E1B4B", color: "white" },
                }}
              >
                Connect with Us
              </Button>
            </Box>
          </Box>
        </Grid>

        <Grid item xs={12} md={6} container spacing={2}>
          {[pic1, pic2].map((pic, index) => (
            <Grid item xs={12} sm={6} key={index}>
              <Box sx={{ position: "relative" , width: 250, height: 400, borderRadius: 2, overflow: "hidden"}}>
                <img src={pic} alt={`Research image ${index + 1}`} style={{ width: "100%", height: "100%", objectFit: "cover" }} />
              </Box>
            </Grid>
          ))}
        </Grid>
      </Grid>
    </Box>
    </Box>
    <FocusAreas/>
    </>
  );
}
